/* eslint-disable jira/filename-case */
export const V3 = 'v3';
export const V4 = 'v4';

export type NavState = typeof V3 | typeof V4;
